import { Directive, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CommandController } from '../../../core/component/base/command-controller.base';
import { ColumnDefinition, ColumnVisibility } from '../../../core/model/column-definition';
import { Command, CommandBase, DeleteCommand, standardCommand } from '../../../core/model/command';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { ConnectedDocumentService } from '../../../rent/service/data/connected-document-base.service';
import { DocumentConnectionBase } from '../../model/document-connection-base';

@Directive({
    standalone: false
})
export abstract class ConnectedDocumentManagerComponent<ConnectionType extends DocumentConnectionBase>
  extends CommandController
  implements OnInit
{
  constructor(
    protected _activatedRoute: ActivatedRoute,
    protected _dataService: ConnectedDocumentService<ConnectionType>,
    private _nativeWindow: NativeWindowService,
    cdf: ColumnDefinitionFactory,
    commandHandlerResolver: StandardCommandHandlerResolver,
    dispatcher: CommandDispatcher
  ) {
    super(dispatcher, commandHandlerResolver);
    this.columnDefinitions = [
      cdf.create('DOCUMENT.CAPTION', 'caption'),
      cdf.createDateTime('DOCUMENT.UPLOADED_DATE', 'uploadedDate'),
      cdf.create('DOCUMENT.SIZE', 'size', ColumnVisibility.optional),
      cdf.createTranslation('DOCUMENT.DOCUMENT_TYPE', 'connectionTypeText', ColumnVisibility.default),
    ];
    this.contextMenuDefinitions = [
      new MenuItemDefinition('DOWNLOAD_BTN', standardCommand.download),
      new MenuItemDefinition('DELETE_BTN', standardCommand.delete),
    ];
  }

  columnDefinitions: ColumnDefinition[];
  contextMenuDefinitions: MenuItemDefinition[];
  items: ConnectionType[];

  canExecute(command: CommandBase): boolean {
    switch (command.id) {
      case standardCommand.delete:
      case standardCommand.download:
        return command instanceof Command && !!command.context;

      default:
        return super.canExecute(command);
    }
  }

  execute(command: CommandBase): void {
    if (command instanceof Command) {
      switch (command.id) {
        case standardCommand.delete:
          const deleteCmd = command as DeleteCommand;
          deleteCmd.itemsSource = this.items;
          deleteCmd.dataService = this._dataService;
          super.execute(deleteCmd);
          break;

        case standardCommand.download:
          this.AddSubscription(
            this._dataService.download((<Command>command).context).subscribe(res => {
              this._nativeWindow.save(res);
            })
          );
          break;
      }
    }
  }

  protected abstract get objectIdParameterName(): string;

  ngOnInit() {
    this.AddSubscription(
      this._activatedRoute.paramMap
        .pipe(
          switchMap(map => {
            let id = map.get(this.objectIdParameterName);
            if (id) {
              return this._dataService.getByOwnerId(id);
            }
            return of([]);
          })
        )
        .subscribe(res => (this.items = res))
    );
  }
}
